import {
    GET_REF_BIKE_LEAD_WITH_REFS_REQUEST_SUCCESS,
    GET_REF_BIKE_LEAD_WITH_REFS_REQUEST_FAILURE,
    CHANGE_LEAD_POT,
} from '../constants/get_lead_profile.constants';

export const getLeadProfileWithRefsRequestSuccess = (payload, key) => ({ type: GET_REF_BIKE_LEAD_WITH_REFS_REQUEST_SUCCESS, payload, key });
export const getLeadProfileWithRefsRequestFailure = (error) => ({ type: GET_REF_BIKE_LEAD_WITH_REFS_REQUEST_FAILURE, error });

export const changeLeadPot = (payload) => ({ type: CHANGE_LEAD_POT, payload });



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/get_lead_profile_with_refs.actions.js